import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { SamplePage } from './components/SamplePage';
import { Testimonials } from './components/Testimonials';
import { firstRoundTestimonials, secondRoundTestimonials } from './data/testimonials';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Comparison } from './components/Comparison';
import { Differentiators } from './components/Differentiators';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen w-full bg-ivory text-ink font-sans selection:bg-gold selection:text-ink" data-id="element-0" data-mp="3rbrbqtqzs5he">
      <MetaPixel data-id="element-1" data-mp="6817u0q2c9h" />
      <main data-id="element-2" data-mp="4n6a3ahwrb3">
        <Hero data-id="element-3" data-mp="56nfhsbnbo2" />
        <SocialProofBar data-id="element-4" data-mp="82j0zgp5o9c" />
        <Testimonials testimonials={firstRoundTestimonials} background="ivory" data-id="element-5" data-mp="2zld2xbxu5jcl" />
        <SamplePage data-id="element-6" data-mp="2zng2amkvootz" />
        <PainGrid data-id="element-7" data-mp="33mf6g4yschkd" />
        <BigIdea data-id="element-8" data-mp="33nq6btp41567" />
        <ProductReveal data-id="element-9" data-mp="33n6zp94wu37h" />
        <Comparison data-id="element-10" data-mp="33orki71fa7s5" />
        <Differentiators data-id="element-11" data-mp="38lrs4mdx7ild" />
        <Tomes data-id="element-12" data-mp="38li6tc3tlzm0" />
        <Bonuses data-id="element-13" data-mp="38l05i12awv78" />
        <Urgency data-id="element-14" data-mp="38kgmeh0x00rm" />
        <Pricing data-id="element-15" data-mp="38o4edbqpof48" />
        <Transformation data-id="element-16" data-mp="3dkl5met7j9lj" />
        <Testimonials testimonials={secondRoundTestimonials} title="More photographers, more Saturdays run right" background="ivory" data-id="element-17" data-mp="3dlw6a5rcw18f" />
        <Guarantee data-id="element-18" data-mp="sudlkfnv5z8s" />
        <Faq data-id="element-19" data-mp="stub1k0jmd4s" />
        <CostOfInaction data-id="element-20" data-mp="stc7e2bjwwmu" />
        <Close data-id="element-21" data-mp="swqc3h7othxg" />
      </main>
      <Footer data-id="element-22" data-mp="3685nh1tcguh" />
      <StickyCta data-id="element-23" data-mp="35yn2ej3lbyt" />
    </div>;
}